// extracted by mini-css-extract-plugin
export default {"saveSentenceBtn":"SentenceBuilder_saveSentenceBtn__2CVrF","divider":"SentenceBuilder_divider__sYQhT","marginTop":"SentenceBuilder_marginTop__sYlAW"};